// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================
   Kubersetu PaisaDaily Page Glass Styles
   ========================================== */

.paisadaily-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 6rem 1.5rem 4rem 1.5rem;
}

/* ===== Hero Section ===== */
.hero-section {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: center;
  background: var(--bg-glass-card);
  backdrop-filter: blur(20px);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border-glass);
  padding: 4rem 3rem;
  margin-bottom: 5rem;
  position: relative;
  overflow: hidden;
  box-shadow: var(--shadow-lg);
}

.hero-content {
  position: relative;
  z-index: 1;
}

.hero-badge {
  display: inline-block;
  background: rgba(245, 158, 11, 0.1);
  padding: 0.5rem 1rem;
  border-radius: var(--radius-full);
  font-size: 0.85rem;
  font-weight: 600;
  color: var(--color-primary);
  letter-spacing: 0.5px;
  margin-bottom: 1.5rem;
  border: 1px solid rgba(245, 158, 11, 0.2);
}

.hero-title {
  font-size: clamp(2.5rem, 4vw, 3.5rem);
  font-weight: 800;
  color: #ffffff;
  line-height: 1.1;
  margin-bottom: 1.5rem;
}

.hero-highlight {
  background: var(--grad-primary);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-description {
  font-size: 1.1rem;
  color: var(--text-muted);
  line-height: 1.7;
  max-width: 480px;
  margin-bottom: 2rem;
}

.hero-actions {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 3rem;
}

.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: var(--grad-primary);
  color: #ffffff;
  border: none;
  padding: 1rem 2rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3);
}

.btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.5);
}

.btn-primary svg {
  transition: transform 0.3s ease;
}

.btn-primary:hover svg {
  transform: translateX(4px);
}

/* Hero Stats */
.hero-stats {
  display: flex;
  align-items: center;
  gap: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid var(--border-glass);
}

.stat-item {
  display: flex;
  flex-direction: column;
}

.stat-number {
  font-size: 1.8rem;
  font-weight: 700;
  color: #ffffff;
}

.stat-label {
  font-size: 0.85rem;
  color: var(--text-muted);
  font-weight: 500;
}

.stat-divider {
  width: 1px;
  height: 40px;
  background: var(--border-glass);
}

/* Hero Visual - Floating Cards */
.hero-visual {
  position: relative;
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.floating-card {
  position: absolute;
  background: rgba(15, 23, 42, 0.6);
  backdrop-filter: blur(12px);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-md);
  padding: 1rem 1.5rem;
  display: flex;
  align-items: center;
  gap: 1rem;
  animation: float 6s ease-in-out infinite;
  box-shadow: var(--shadow-lg);
}

.floating-card span {
  font-size: 1.8rem;
}

.floating-card p {
  color: #ffffff;
  font-weight: 600;
  font-size: 0.95rem;
}

.floating-card.card-1 {
  top: 10%;
  right: 10%;
  animation-delay: 0s;
}

.floating-card.card-2 {
  bottom: 30%;
  left: 0%;
  animation-delay: 2s;
}

.floating-card.card-3 {
  bottom: 10%;
  right: 30%;
  animation-delay: 4s;
}

@keyframes float {
  0%, 100% { transform: translateY(0px); }
  50% { transform: translateY(-16px); }
}

/* ===== Features Section ===== */
.features-section {
  margin-bottom: 5rem;
}

.section-header {
  text-align: center;
  margin-bottom: 3.5rem;
}

.section-tag {
  display: inline-block;
  font-size: 0.8rem;
  font-weight: 600;
  color: var(--color-primary);
  text-transform: uppercase;
  letter-spacing: 2px;
  background: rgba(245, 158, 11, 0.1);
  padding: 0.25rem 1rem;
  border-radius: var(--radius-full);
  margin-bottom: 1rem;
}

.section-title {
  font-size: clamp(2rem, 4vw, 2.8rem);
  font-weight: 800;
  color: #ffffff;
  line-height: 1.2;
}

.section-title span {
  color: var(--color-primary);
}

.section-subtitle {
  font-size: 1.1rem;
  color: var(--text-muted);
  margin-top: 1rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.feature-card {
  background: var(--bg-glass-card);
  backdrop-filter: blur(16px);
  padding: 2rem;
  border-radius: var(--radius-lg);
  text-align: center;
  transition: all 0.4s ease;
  border: 1px solid var(--border-glass);
}

.feature-card:hover {
  transform: translateY(-8px);
  border-color: rgba(255,255,255,0.2);
  box-shadow: var(--shadow-lg);
}

.feature-icon {
  font-size: 2.8rem;
  display: block;
  margin-bottom: 1.5rem;
}

.feature-card h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 0.75rem;
}

.feature-card p {
  font-size: 0.95rem;
  color: var(--text-muted);
  line-height: 1.6;
}

/* ===== CTA Section ===== */
.cta-section {
  background: var(--grad-surface);
  border: 1px solid var(--border-glass);
  border-radius: var(--radius-lg);
  padding: 4rem 3rem;
  margin-bottom: 4rem;
  text-align: center;
  position: relative;
  overflow: hidden;
  box-shadow: var(--shadow-lg);
}

.cta-content {
  position: relative;
  z-index: 1;
}

.cta-content h2 {
  font-size: clamp(2rem, 4vw, 2.8rem);
  font-weight: 800;
  color: #ffffff;
  margin-bottom: 1rem;
}

.cta-content p {
  font-size: 1.1rem;
  color: var(--text-muted);
  margin-bottom: 2rem;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
}

.btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
  border: 1px solid rgba(255, 255, 255, 0.2);
  padding: 1rem 2.5rem;
  font-size: 1rem;
  font-weight: 600;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-secondary:hover {
  transform: translateY(-3px);
  background: rgba(255, 255, 255, 0.15);
}

.btn-secondary svg {
  transition: transform 0.3s ease;
}

.btn-secondary:hover svg {
  transform: translateX(4px);
}

.cta-note {
  display: block;
  font-size: 0.85rem;
  color: var(--text-muted);
  margin-top: 1.5rem;
}

/* ===== Support Section ===== */
.support-section {
  background: var(--bg-glass-card);
  backdrop-filter: blur(16px);
  border-radius: var(--radius-lg);
  padding: 3rem;
  margin-bottom: 4rem;
  border: 1px solid var(--border-glass);
}

.support-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
}

.support-text {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.support-icon {
  font-size: 2.5rem;
}

.support-text h3 {
  font-size: 1.25rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 0.25rem;
}

.support-text p {
  color: var(--text-muted);
  font-size: 0.95rem;
}

.support-phone {
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  background: rgba(15, 23, 42, 0.6);
  color: #ffffff;
  padding: 1rem 2rem;
  border-radius: var(--radius-md);
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s ease;
  border: 1px solid var(--border-glass);
}

.support-phone:hover {
  background: var(--color-primary);
  border-color: var(--color-primary);
  transform: translateY(-2px);
  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3);
}

/* ===== Footer ===== */
.paisadaily-footer {
  text-align: center;
  padding: 1.5rem 0;
  color: var(--text-muted);
  font-size: 0.85rem;
  border-top: 1px solid var(--border-glass);
}

/* ===== Responsive ===== */
@media (max-width: 1024px) {
  .hero-section {
    grid-template-columns: 1fr;
    padding: 3rem 2rem;
  }
  .hero-visual {
    display: none;
  }
}
@media (max-width: 768px) {
  .hero-stats {
    flex-wrap: wrap;
  }
  .stat-divider {
    display: none;
  }
  .support-content {
    flex-direction: column;
    text-align: center;
  }
  .support-text {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/PaisaDaily.css"],"names":[],"mappings":"AAAA;;+CAE+C;;AAE/C;EACE,iBAAiB;EACjB,cAAc;EACd,gCAAgC;AAClC;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,gCAAgC;EAChC,2BAA2B;EAC3B,+BAA+B;EAC/B,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,oBAAoB;EACpB,iCAAiC;EACjC,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,+BAA+B;EAC/B,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,+BAA+B;AACjC;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,2BAA2B;EAC3B,qCAAqC;EACrC,+BAA+B;EAC/B,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW,0BAA0B,EAAE;EACvC,MAAM,4BAA4B,EAAE;AACtC;;AAEA,iCAAiC;AACjC;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,mCAAmC;EACnC,qBAAqB;EACrB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,aAAa;EACb,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;EACnC,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oCAAoC;EACpC,cAAc;EACd,0CAA0C;EAC1C,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iCAAiC;EACjC,cAAc;EACd,kBAAkB;EAClB,+BAA+B;EAC/B,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA,2BAA2B;AAC3B;EACE;IACE,0BAA0B;IAC1B,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;AACF;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA;IACE,sBAAsB;IACtB,kBAAkB;EACpB;EACA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* ==========================================\n   Kubersetu PaisaDaily Page Glass Styles\n   ========================================== */\n\n.paisadaily-container {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 6rem 1.5rem 4rem 1.5rem;\n}\n\n/* ===== Hero Section ===== */\n.hero-section {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 3rem;\n  align-items: center;\n  background: var(--bg-glass-card);\n  backdrop-filter: blur(20px);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border-glass);\n  padding: 4rem 3rem;\n  margin-bottom: 5rem;\n  position: relative;\n  overflow: hidden;\n  box-shadow: var(--shadow-lg);\n}\n\n.hero-content {\n  position: relative;\n  z-index: 1;\n}\n\n.hero-badge {\n  display: inline-block;\n  background: rgba(245, 158, 11, 0.1);\n  padding: 0.5rem 1rem;\n  border-radius: var(--radius-full);\n  font-size: 0.85rem;\n  font-weight: 600;\n  color: var(--color-primary);\n  letter-spacing: 0.5px;\n  margin-bottom: 1.5rem;\n  border: 1px solid rgba(245, 158, 11, 0.2);\n}\n\n.hero-title {\n  font-size: clamp(2.5rem, 4vw, 3.5rem);\n  font-weight: 800;\n  color: #ffffff;\n  line-height: 1.1;\n  margin-bottom: 1.5rem;\n}\n\n.hero-highlight {\n  background: var(--grad-primary);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.hero-description {\n  font-size: 1.1rem;\n  color: var(--text-muted);\n  line-height: 1.7;\n  max-width: 480px;\n  margin-bottom: 2rem;\n}\n\n.hero-actions {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  margin-bottom: 3rem;\n}\n\n.btn-primary {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: var(--grad-primary);\n  color: #ffffff;\n  border: none;\n  padding: 1rem 2rem;\n  font-size: 1rem;\n  font-weight: 600;\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3);\n}\n\n.btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(245, 158, 11, 0.5);\n}\n\n.btn-primary svg {\n  transition: transform 0.3s ease;\n}\n\n.btn-primary:hover svg {\n  transform: translateX(4px);\n}\n\n/* Hero Stats */\n.hero-stats {\n  display: flex;\n  align-items: center;\n  gap: 2rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid var(--border-glass);\n}\n\n.stat-item {\n  display: flex;\n  flex-direction: column;\n}\n\n.stat-number {\n  font-size: 1.8rem;\n  font-weight: 700;\n  color: #ffffff;\n}\n\n.stat-label {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  font-weight: 500;\n}\n\n.stat-divider {\n  width: 1px;\n  height: 40px;\n  background: var(--border-glass);\n}\n\n/* Hero Visual - Floating Cards */\n.hero-visual {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100%;\n}\n\n.floating-card {\n  position: absolute;\n  background: rgba(15, 23, 42, 0.6);\n  backdrop-filter: blur(12px);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-md);\n  padding: 1rem 1.5rem;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  animation: float 6s ease-in-out infinite;\n  box-shadow: var(--shadow-lg);\n}\n\n.floating-card span {\n  font-size: 1.8rem;\n}\n\n.floating-card p {\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 0.95rem;\n}\n\n.floating-card.card-1 {\n  top: 10%;\n  right: 10%;\n  animation-delay: 0s;\n}\n\n.floating-card.card-2 {\n  bottom: 30%;\n  left: 0%;\n  animation-delay: 2s;\n}\n\n.floating-card.card-3 {\n  bottom: 10%;\n  right: 30%;\n  animation-delay: 4s;\n}\n\n@keyframes float {\n  0%, 100% { transform: translateY(0px); }\n  50% { transform: translateY(-16px); }\n}\n\n/* ===== Features Section ===== */\n.features-section {\n  margin-bottom: 5rem;\n}\n\n.section-header {\n  text-align: center;\n  margin-bottom: 3.5rem;\n}\n\n.section-tag {\n  display: inline-block;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: var(--color-primary);\n  text-transform: uppercase;\n  letter-spacing: 2px;\n  background: rgba(245, 158, 11, 0.1);\n  padding: 0.25rem 1rem;\n  border-radius: var(--radius-full);\n  margin-bottom: 1rem;\n}\n\n.section-title {\n  font-size: clamp(2rem, 4vw, 2.8rem);\n  font-weight: 800;\n  color: #ffffff;\n  line-height: 1.2;\n}\n\n.section-title span {\n  color: var(--color-primary);\n}\n\n.section-subtitle {\n  font-size: 1.1rem;\n  color: var(--text-muted);\n  margin-top: 1rem;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.features-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n}\n\n.feature-card {\n  background: var(--bg-glass-card);\n  backdrop-filter: blur(16px);\n  padding: 2rem;\n  border-radius: var(--radius-lg);\n  text-align: center;\n  transition: all 0.4s ease;\n  border: 1px solid var(--border-glass);\n}\n\n.feature-card:hover {\n  transform: translateY(-8px);\n  border-color: rgba(255,255,255,0.2);\n  box-shadow: var(--shadow-lg);\n}\n\n.feature-icon {\n  font-size: 2.8rem;\n  display: block;\n  margin-bottom: 1.5rem;\n}\n\n.feature-card h3 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 0.75rem;\n}\n\n.feature-card p {\n  font-size: 0.95rem;\n  color: var(--text-muted);\n  line-height: 1.6;\n}\n\n/* ===== CTA Section ===== */\n.cta-section {\n  background: var(--grad-surface);\n  border: 1px solid var(--border-glass);\n  border-radius: var(--radius-lg);\n  padding: 4rem 3rem;\n  margin-bottom: 4rem;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n  box-shadow: var(--shadow-lg);\n}\n\n.cta-content {\n  position: relative;\n  z-index: 1;\n}\n\n.cta-content h2 {\n  font-size: clamp(2rem, 4vw, 2.8rem);\n  font-weight: 800;\n  color: #ffffff;\n  margin-bottom: 1rem;\n}\n\n.cta-content p {\n  font-size: 1.1rem;\n  color: var(--text-muted);\n  margin-bottom: 2rem;\n  max-width: 600px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.btn-secondary {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  padding: 1rem 2.5rem;\n  font-size: 1rem;\n  font-weight: 600;\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-secondary:hover {\n  transform: translateY(-3px);\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.btn-secondary svg {\n  transition: transform 0.3s ease;\n}\n\n.btn-secondary:hover svg {\n  transform: translateX(4px);\n}\n\n.cta-note {\n  display: block;\n  font-size: 0.85rem;\n  color: var(--text-muted);\n  margin-top: 1.5rem;\n}\n\n/* ===== Support Section ===== */\n.support-section {\n  background: var(--bg-glass-card);\n  backdrop-filter: blur(16px);\n  border-radius: var(--radius-lg);\n  padding: 3rem;\n  margin-bottom: 4rem;\n  border: 1px solid var(--border-glass);\n}\n\n.support-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 2rem;\n}\n\n.support-text {\n  display: flex;\n  align-items: center;\n  gap: 1.5rem;\n}\n\n.support-icon {\n  font-size: 2.5rem;\n}\n\n.support-text h3 {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #ffffff;\n  margin-bottom: 0.25rem;\n}\n\n.support-text p {\n  color: var(--text-muted);\n  font-size: 0.95rem;\n}\n\n.support-phone {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.75rem;\n  background: rgba(15, 23, 42, 0.6);\n  color: #ffffff;\n  padding: 1rem 2rem;\n  border-radius: var(--radius-md);\n  text-decoration: none;\n  font-weight: 600;\n  transition: all 0.3s ease;\n  border: 1px solid var(--border-glass);\n}\n\n.support-phone:hover {\n  background: var(--color-primary);\n  border-color: var(--color-primary);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 15px rgba(245, 158, 11, 0.3);\n}\n\n/* ===== Footer ===== */\n.paisadaily-footer {\n  text-align: center;\n  padding: 1.5rem 0;\n  color: var(--text-muted);\n  font-size: 0.85rem;\n  border-top: 1px solid var(--border-glass);\n}\n\n/* ===== Responsive ===== */\n@media (max-width: 1024px) {\n  .hero-section {\n    grid-template-columns: 1fr;\n    padding: 3rem 2rem;\n  }\n  .hero-visual {\n    display: none;\n  }\n}\n@media (max-width: 768px) {\n  .hero-stats {\n    flex-wrap: wrap;\n  }\n  .stat-divider {\n    display: none;\n  }\n  .support-content {\n    flex-direction: column;\n    text-align: center;\n  }\n  .support-text {\n    flex-direction: column;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
